import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { secureStorage } from '../../../shared/services/encryption/secureservice';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from '../../services/behaviour-subject.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit,OnChanges  {
  @Input() data: any;
  breadcrumbdata: any = [];
  breadcrumbs: any = [];
  hidebreadcrumb = false;

  constructor(private activatedRoute: ActivatedRoute, private localStorage: secureStorage,    private behaviorService: BehaviourSubjectService,

    @Inject(PLATFORM_ID) private platformId: Object, private router: Router,) {

     }
     ngOnChanges(changes: SimpleChanges) {
      if (changes['data']) {
        this.breadcrumbs=changes['data'].currentValue
      }
    }

  ngOnInit(): void {
    this.breadcrumbs = [];
    this.activatedRoute.data.subscribe(d => {
      this.data = d;

    })

    this.getBreadCrumb()

  }

  getBreadCrumb(){
    if (isPlatformBrowser(this.platformId)) {
    this.breadcrumbs = this.localStorage.getItem('localBreadCrumb') ? JSON.parse(this.localStorage.getItem('localBreadCrumb')) : [];
    }
    if (this.breadcrumbs == undefined || this.breadcrumbs == null) {
      this.hidebreadcrumb = true;
    }
  }

  GotoRoute(breadcrumb, index) {
    let labels = breadcrumb.label?.toLowerCase();
      if(labels == 'trucks' || labels == 'buses & vans' || labels == 'scv pickups' || labels == 'brand' ){
        return
      }
    if (isPlatformBrowser(this.platformId)) {
      this.breadcrumbs.splice(index + 1, this.breadcrumbs?.length - index);
      if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('localBreadCrumb');
      this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbs));
      }
      this.router.navigate([breadcrumb.url]);
      this.behaviorService.isSmart.next(false);
    }
  }

  getCursor(label)
  {
    let labels = label?.toLowerCase();
      if(labels == 'trucks' || labels == 'buses & vans' || labels == 'scv pickups' || labels == 'brand'){
        return 'default';
      }
  }
}
